import { RootState } from '../../Presentation/store';

export const selectUrlRankState = (state: RootState) => state.urlRank;
export const selectUrlRankLoading = (state: RootState) => state.urlRank.loading;
export const selectUrlRankPolling = (state: RootState) => state.urlRank.polling;
export const selectUrlRankJobId = (state: RootState) => state.urlRank.jobId;
export const selectUrlRankSearchRange = (state: RootState) => state.urlRank.searchRange;
export const selectUrlRankResult = (state: RootState) => state.urlRank.result;
export const selectUrlRankError = (state: RootState) => state.urlRank.error;
